import { lazy } from 'react'
import lazyLoad from './LazyLoad'

// 视频相关
export const uBoxMachineRouter = [
  {
    element: lazyLoad(lazy(() => import('@/pages/uBoxMachine/introduce'))),
    path: '/uBoxMachine/introduce',
  },
  {
    element: lazyLoad(lazy(() => import('@/pages/uBoxMachine/doc'))),
    path: '/uBoxMachine/doc',
  },
  {
    element: lazyLoad(lazy(() => import('@/pages/uBoxMachine/picIntroduce'))),
    path: '/uBoxMachine/picIntroduce',
  },
  // doc
]